/* eslint-disable @typescript-eslint/no-explicit-any */
import { AfterViewInit, ChangeDetectorRef, NgZone, QueryList, inject } from '@angular/core';
import { Component, OnInit, ViewChildren } from '@angular/core';
import { NgStyle } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';
import { CdsButtonConfig } from '@cds/ng-core/button';
import { CdsLanguageModule } from '@cds/ng-core/lang';
import { CdsIconModule } from '@cds/ng-web-components/icon';
import { CdsOption } from '@cds/ng-core/configuration';
import { CdsMenuItemComponent, CdsNavigationModule } from '@cds/ng-web-components/navigation';
import { Subject } from 'rxjs';
import { Menu } from 'src/app/core/models/menu';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { PermissionService } from 'src/app/core/services/permission.service';
import { LanguageChangeService } from 'src/app/shared/language-change.service';
import { environment } from 'src/environments/environment';
import { LoginType } from '../../user/login/login.component';
import { NotifyService } from 'src/app/core/services/notify.service';
import { loadGoHomeFunc } from 'src/app/utils/utils';
import { createCopyrightYear } from 'src/app/utils/dateUtils';
import { AdminHeaderComponent } from './admin-header/admin-header.component';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
  imports: [CdsNavigationModule, NgStyle, AdminHeaderComponent, RouterOutlet, CdsIconModule, CdsLanguageModule],
})
export class AdminLayoutComponent implements OnInit, AfterViewInit {
  private authenticationService = inject(AuthenticationService);
  private permissionService = inject(PermissionService);
  private languageChangeService = inject(LanguageChangeService);
  private router = inject(Router);
  private notifyService = inject(NotifyService);
  private changeDetectorRef = inject(ChangeDetectorRef);
  private ngZone = inject(NgZone);

  @ViewChildren('menuItem') menuItemList!: QueryList<CdsMenuItemComponent>;
  menus: Menu[] = [];
  currentUser: any;
  copyright = createCopyrightYear();
  // copyright = `© Manulife (International) Limited ${environment.organizationDay}-${new Date().getFullYear()}`;
  version = `V ${environment.appVersion}`;
  langList: CdsOption[] = environment.languageList;
  selectedLang = 'en';
  isHideNavigationLang = false;
  private sharData: Subject<string> = new Subject();

  btnCfg: CdsButtonConfig = {
    style: 'tertiary',
    size: 'sm',
  };

  go(link?: string) {
    if (link) {
      if (link.indexOf('?') !== -1) {
        const linkP = link.split('?');
        const url = linkP[0];
        const parmasList = linkP[1].split('&');
        const parmas: any = [];
        parmasList.forEach(x => {
          const temp = x.split('=');
          parmas[temp[0]] = temp[1];
        });
        this.router.navigateByUrl('/error', { skipLocationChange: true }).then(() => this.router.navigate([url], { queryParams: { ...parmas } }));
        return;
      }
      this.router.navigate([link]);
    }
  }

  ngOnInit(): void {
    this.permissionService.initMenu().then(menus => {
      this.ngZone.run(() => {
        this.menus = [...menus];
        this.changeDetectorRef.detectChanges();

        // Force a post-render layout pass for cds-navigation to avoid stale side menu paint until hover.
        requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
      });
    });

    this.notifyService.getHideNavigationLang().subscribe(boo => {
      setTimeout(() => {
        this.isHideNavigationLang = boo;
        const mobileNavigation = document.querySelector('div.cds-mobile-menu-util.order-1 cds-navigation-dropdown-utility');
        if (mobileNavigation && mobileNavigation.parentElement) {
          (mobileNavigation.parentElement as HTMLElement).style.display = boo ? 'none' : 'unset';
        }
      }, 100);
    });

    this.languageChangeService.initLanNotice.subscribe(lang => {
      this.selectedLang = lang;
    });
  }

  ngAfterViewInit(): void {
    loadGoHomeFunc(() => {
      this.router.navigate(['/home']);
    });
  }

  logout() {
    let loginType = localStorage.getItem('loginType') as LoginType;
    if (!loginType) {
      loginType = 'sso';
    }
    this.authenticationService.logout(loginType, this.router);
  }

  changeLang(lang: string) {
    this.selectedLang = lang;
    this.languageChangeService.setLang(lang);
    this.sendData(lang);
  }

  sendData(value: string) {
    this.sharData.next(value);
  }

  getLanguage() {
    return this.sharData;
  }
}
